<template>
    <div >
      <el-dialog title="扫描数据总览" width="60%" :visible.sync="dialogVisible" :close-on-click-modal="false" @open="handleDialogOpen" @close="cancel">
        <div style="display: grid; justify-items: end; ">
          <el-button type="primary"  @click="outputXlsxFile" style="margin-right: 5%;">导 出</el-button>
          <span >含作弊缺考和未扫描数据</span>
        </div>
        
        <el-tabs v-model="activeName" @tab-click="handleClick">
          <el-tab-pane label="行政班" name="hardClass"></el-tab-pane>
          <el-tab-pane label="教学班" name="teachingClass"></el-tab-pane>
          <el-tab-pane label="作弊缺考" name="species"></el-tab-pane>
          <el-tab-pane label="未扫描名单" name="loseScan"></el-tab-pane>
        </el-tabs>

        
        <div style="width: 100%; height: auto;">
          <el-table :data="tableData" :key="activeName" max-height="500" style="width: 100%">
            <el-table-column type="index" width="70" label="序号"></el-table-column>
            <el-table-column prop="hard_name" label="行政班名称" v-if="activeName === 'hardClass'"></el-table-column>
            <el-table-column prop="stu_count" label="班级学生"  width="200" v-if="activeName === 'hardClass'"></el-table-column>
            <el-table-column prop="scan_count" label="已扫描人数" width="200" v-if="activeName === 'hardClass'"></el-table-column>

            <el-table-column prop="name" label="教学班名称" v-if="activeName === 'teachingClass'"></el-table-column>
            <el-table-column prop="student_count" label="教学班学生" width="200"  v-if="activeName === 'teachingClass'"></el-table-column>
            <el-table-column prop="kg_count" label="已扫描人数"  width="200" v-if="activeName === 'teachingClass'"></el-table-column>

            <!-- <el-table v-loading="loading" v-if="classMode==1" :data="teachingClassData" style="width: 100%"  :height="tableHeight" align='center'>
                <el-table-column prop="name" label="教学班名称" width="240" align='center' ></el-table-column>
                <el-table-column prop="student_count" label="教学班学生" width="100"  align='center' ></el-table-column>
                <el-table-column prop="kg_count" label="考试人数" width="100"  align='center' > -->

            <el-table-column prop="hard_name" label="班级名称" v-if="activeName === 'species'"></el-table-column>
            <el-table-column prop="student_no" label="学号" width="200"  v-if="activeName === 'species'"></el-table-column>
            <el-table-column prop="student_name" label="学生姓名" width="200" v-if="activeName === 'species'"></el-table-column>
            <el-table-column prop="status" label="状态" width="200" v-if="activeName === 'species'">
              <template slot-scope='scope'>
                <span v-if="scope.row.status == 'ZB'"> 作弊</span>
                <span v-if="scope.row.status == 'QK'"> 缺考</span>
              </template>
            </el-table-column>

            <el-table-column prop="hard_name" label="行政班级名称" v-if="activeName === 'loseScan' && !isTeacher "></el-table-column>
            <el-table-column prop="hard_name" label="行政班级名称" v-if="activeName === 'loseScan' && isTeacher "></el-table-column>
            <el-table-column prop="teacher_class_name" label="教学班级名称" v-if="activeName === 'loseScan' && isTeacher "></el-table-column>
            <el-table-column prop="student_no" label="学号" width="200"  v-if="activeName === 'loseScan'"></el-table-column>
            <el-table-column prop="student_name" label="学生名称" width="200" v-if="activeName === 'loseScan'"></el-table-column>
            <!-- <el-table-column prop="hard_name" label="班级名称" v-if="activeName === 'loseScan'"></el-table-column> -->

          </el-table>
          <div style="display: flex; justify-content: flex-end;margin-top: 20px;margin-right: 20px;">
            <span style="font-size: 20px; font-weight: bold;">总数：{{ tableData.length }}</span>
          </div>
        </div>


        <div slot="footer" class="dialog-footer">
            <el-button @click="cancel">取 消</el-button>
        </div>



      </el-dialog>

    </div>
</template>

<script>
  import {mapGetters, mapState} from "vuex";
  import * as simpleApi from "request/simple";
  import XEUtils from 'xe-utils'
  import * as mUtils from '@/utils/mUtils'
  import XLSX from "xlsx";
  import dayjs from 'dayjs'

  export default {
      name: 'overviewExamDialog',
      data(){
        return {
          dialogVisible: false,
          examInfo: null,
          examId: null,
          // 行政班数据
          hardClassList:[],
          // 教学班数据
          teachingClassList:[],
          // 作弊缺考学生列表
          speciesStudentsList:[],
          // 未扫描学生列表
          loseScanStudentsList:[],
          loseScanStudentsListTeacher:[],
          // 默认选中标签页
          activeName: 'hardClass',
          // 是否配置教学班
          isTeacherType: false,
          // 教学班列表
          teachingIds:[],
          isTeacher: true,
          tableData:[],
          

        }
      },
      components:{

      },
      computed:{
        ...mapState({
            userInfo: state => state.user.userInfo,
        }),
      },
    mounted() {},
    props: {},
    watch: {},
    methods: {
      showDialog(item){
        this.examInfo = item
        this.examId = item.id
        // 考试规则判空 过滤教学班，并判断是否配置了教学班
        let rules = item.rules
        if(rules != null && rules != '' && rules != undefined){
        
          rules = JSON.parse(item.rules);
          if(rules && "teachingClassList" in rules){
            // 配置了教学班
            this.isTeacherType = true
            // this.teachingIds = [];
            let ids = []
            let teachingList = rules.teachingClassList
            teachingList.forEach((item, index) => {
              ids.push(item.id);
            });
            this.teachingIds = ids
          }
        }
        this.dialogVisible = true
      },
      // 打开窗口时进行调用
      handleDialogOpen(){
        this.loadHardClass()
        this.loadTeachingClass()
        this.loadSpeciesStudents()
        // this.loadNotScanStudents()
        // 行政班缺失学生
        // this.loadLoseExams()
        // 教学班缺失学生
        this.loadLoseTeachingExams()
      },
      // 点击标签页
      handleClick(tab, event){
        let activeName = tab.name
        this.activeName = activeName
        if(activeName === 'hardClass'){
          this.tableData = this.hardClassList
        }else if(activeName === 'teachingClass'){
          this.tableData = this.teachingClassList
        }else if(activeName === 'species'){
          this.tableData = this.speciesStudentsList
        }else if(activeName === 'loseScan'){
          // 判断表格显示数据（行政班/教学班）
          this.loadNotScanStudents()
        }
      },
      // 加载行政班列表
      loadHardClass(){
        let search = { createrId: this.userInfo.id, examId: this.examId,licenceId: this.userInfo.licenceId, orderBy: 'id desc'};
        let param = { controllerName: 'examTask', methodName: '/byReCheckExamId',  param: search};
        return simpleApi.list(param).then(({result: {code, data}}) =>  {
          if (code == 0) {
            // 获取到行政班列表
            this.hardClassList = data.hardClassList
            this.tableData = data.hardClassList
            this.loadLoseExams()
          }
        })
      },
      // 加载教学班列表
      loadTeachingClass(){
        if(this.teachingIds.length == 0) return ;
        // this.teachingIds = []
        // if(this.examInfo && this.examInfo.rules != null){
            // let rules = JSON.parse(this.examInfo.rules);
            // if(rules && "teachingClassList" in rules){
            //   // 配置了教学班
            //   this.isTeacherType = true
            //   let teachingIds = [];
            //   let teachingList = rules.teachingClassList
            //   teachingList.forEach((item, index) => {
            //       teachingIds.push(item.id);
            //   });
            //   if(teachingIds.length == 0) return ;
              // this.teachingIds = teachingIds
          let search = { inTeachingClass: this.teachingIds, examId: this.examId};
          let param = { controllerName: 'examTask', methodName: '/teachingClass',  param: search};
          return simpleApi.list(param).then(({result: {code, data}}) => {
            if (code == 0) {
              this.teachingClassList = data
            }
          })

            // }
        // }
      },
      // 加载作弊缺考学生
      loadSpeciesStudents(){
        let search = { examId: this.examId,licenceId: this.userInfo.licenceId,groupBy: 'studentId'};
        let param = { controllerName: 'exam', methodName: '/specialAll',  param: search};
        return simpleApi.list(param).then(({result: {code, data}}) => {
          if (code == 0) {
            this.speciesStudentsList = data
          }
        })
      },
      // 加载未扫描学生(有教学班以教学班未先)
      loadNotScanStudents(){
        // debugger
        this.tableData = []
        this.isTeacher = false
        // 判断教学班缺失学生是否存在，存在则显示，不存在就显示行政班
        if(this.loseScanStudentsListTeacher.length >0){
          this.isTeacher = true
          this.tableData= this.loseScanStudentsListTeacher
        }else{
          this.tableData = this.loseScanStudentsList
        }



        // if(this.isTeacher){
        //   // 如果有配置教学班但是对应的缺考名单没有，就显示行政班
        //   if(this.teachingIds.length == 0){
        //     this.tableData = this.loseScanStudentsList
        //   }else{
        //     this.tableData = this.loseScanStudentsListTeacher
        //   }
        // }else{
        //   this.tableData = this.loseScanStudentsList
        // }



        // debugger
        // this.tableData = []
        // this.loseScanStudentsList = []
        // if(this.teachingIds.length >0){
        //   this.isTeacher = false
        //   this.loadLoseTeachingExams()
        // }else{
        //   this.isTeacher = true
        //   this.loadLoseExams()
        // }
      },
      loadLoseExams(){
        console.log("111");
        if(this.hardClassList.length == 0){
          // this.tableData = []
          this.loseScanStudentsList = []
          return
        }
        let hardClassIds = []
        this.hardClassList.forEach((item, index) => {
          hardClassIds.push(item.id);
        });
        let search = { examId: this.examId, hardClassIds: hardClassIds };
        let param = { controllerName: 'examTask', methodName: '/loseExamStudent',  param: search};
        return simpleApi.list(param).then(({result: {code, data}}) =>  {
            if (code == 0 && data && data.length > 0) {
              //  this.tableData = data
               this.loseScanStudentsList = data
            }

        }).catch((error) => {
            console.log("error")
        });
      },
      loadLoseTeachingExams(){
        this.loseScanStudentsListTeacher = []
        if(this.teachingIds.length == 0) return ;

        let search = { examId: this.examId, teachingClassIds: this.teachingIds };
        let param = { controllerName: 'examTask', methodName: '/loseTeachingExamStudent',  param: search};
        return simpleApi.list(param).then(({result: {code, data}}) =>  {
            if (code == 0 && data && data.length > 0) {
              // this.tableData = data
              this.loseScanStudentsListTeacher = data
            }
        }).catch((error) => {
            console.log("error")
        });
      },
      outputXlsxFile() {

        let time_ = dayjs().format('YYYYMMDD_HHmm') 
        let fileName = this.examInfo.name + '(' + this.examId + ')-扫描数据总览表_' + time_ +'.xlsx'

        // 作弊工作表
        let species = this.speciesStudentsList
        let speciesData = XEUtils.sortBy(species, ['hard_name', 'student_no']);
        let slst = [['行政班', '学号', '姓名']];
        for (let i=0; i<speciesData.length; i++){
            let d = speciesData[i];
            slst.push([d.hard_name, d.student_no, d.student_name]);
        }

        // 未扫描名单(有教学班导出教学班，无教学班导出行政班)
  
        let loseS = this.loseScanStudentsList
        if(this.loseScanStudentsListTeacher.length >0){
          loseS = this.loseScanStudentsListTeacher
        }
        
        let myData = XEUtils.sortBy(loseS, ['hard_name', 'student_no']);
        let lst = [['行政班', '学号', '姓名']];
        for (let i=0; i<myData.length; i++){
            let d = myData[i];
            lst.push([d.hard_name, d.student_no, d.student_name]);
        }

        let wb = XLSX.utils.book_new();
        // 创建第一个工作表
        let sheet1 = XLSX.utils.aoa_to_sheet(slst);
        XLSX.utils.book_append_sheet(wb, sheet1, "作弊缺考");

        // 创建第二个工作表
        let sheet2 = XLSX.utils.aoa_to_sheet(lst);
        XLSX.utils.book_append_sheet(wb, sheet2, "未扫描学生");

        XLSX.writeFile(wb, fileName);

        // XLSX.writeFile(wb, "扫描数据总览表.xlsx");
      },
      // 取消
      cancel(){
        // 清空数据
        this.hardClassList = []
        this.teachingIds= []
        this.teachingClassList = []
        this.speciesStudentsList = []
        this.loseScanStudentsList = []
        this.loseScanStudentsListTeacher = []
        this.activeName = 'hardClass'
        this.dialogVisible = false
      }
      
    },
  }
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">



</style>


